import { Routes } from '@angular/router';

export default [
  {
    path: '',
    loadComponent: () => import('./cabinet'),
  },
] as Routes;
